export const PermissionRequirement = Object.freeze({
  /**
   * Every permission in the permissions list is required
   */
  ALL: 'all',
  /**
   * At least one permission out of the list is required
   */
  ONE: 'one',
})
